export default function getServiceName(serviceName: string): string {
  serviceName = serviceName.replace(/_/g, '-');
  return `/api/v1/${serviceName}`;
}
